import React, { Fragment } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { ArrowRight } from 'lucide-react';
const steps = [{
  num: '01',
  title: 'Aprendés el Sistema',
  desc: 'Dominás el método exacto para pedirle a la IA lo que necesitás',
  color: 'bg-gold',
  shadow: 'shadow-gold/20',
  textColor: 'text-navy'
}, {
  num: '02',
  title: 'Aplicás los Prompts',
  desc: 'Usás nuestro Banco de Prompts diseñado para docentes',
  color: 'bg-electric',
  shadow: 'shadow-electric/20',
  textColor: 'text-white'
}, {
  num: '03',
  title: 'Creás tu Material',
  desc: 'Generás planificaciones, actividades y evaluaciones en 10 minutos. Para siempre.',
  color: 'bg-emerald',
  shadow: 'shadow-emerald/20',
  textColor: 'text-white'
}];
export function SolutionSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section className="w-full bg-navy py-14 px-4 sm:px-6 lg:px-8" data-id="element-170">
      <div ref={ref} className={`max-w-5xl mx-auto transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-171">
        <div className="text-center mb-10" data-id="element-172">
          <span className="inline-block font-montserrat font-bold text-gold text-sm tracking-widest uppercase mb-3" data-id="element-173">
            LA SOLUCIÓN DEFINITIVA
          </span>
          <h2 className="font-playfair font-bold text-2xl sm:text-[38px] leading-[1.2] text-white" data-id="element-174">
            No Compres Más Material de Otros. Aprendé a Crear el Tuyo.{' '}
            <span className="relative inline-block" data-id="element-175">
              Para Siempre.
              <span className="absolute -bottom-1 left-0 w-full h-1 bg-gold rounded-full" data-id="element-176"></span>
            </span>
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-2" data-id="element-177">
          {steps.map((step, idx) => <Fragment key={idx} data-id="element-178">
              <div className="flex-1 flex items-center gap-4 sm:flex-col sm:text-center text-left" data-id="element-179">
                <div className={`w-14 h-14 sm:w-16 sm:h-16 rounded-full ${step.color} flex items-center justify-center shadow-lg ${step.shadow} flex-shrink-0`} data-id="element-180">
                  <span className={`font-montserrat font-black text-xl sm:text-2xl ${step.textColor}`} data-id="element-181">
                    {step.num}
                  </span>
                </div>
                <div className="sm:mt-3" data-id="element-182">
                  <h3 className="font-playfair font-bold text-lg text-white mb-1" data-id="element-183">
                    {step.title}
                  </h3>
                  <p className="font-inter text-[#A8B2D8] text-sm leading-snug sm:max-w-[200px] sm:mx-auto" data-id="element-184">
                    {step.desc}
                  </p>
                </div>
              </div>
              {idx < steps.length - 1 && <div className="hidden sm:flex text-gold/60 flex-shrink-0" data-id="element-185">
                  <ArrowRight size={28} strokeWidth={1.5} data-id="element-186" />
                </div>}
            </Fragment>)}
        </div>
      </div>
    </section>;
}